module.exports = __webpack_public_path__ + "img/EWA.c9344283.png";